// extracted by mini-css-extract-plugin
export default {"container":"L_g","sectionTitle":"L_fm","sectionImage":"L_fn","downloadButton":"L_fp"};